import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Button, Form } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class ReceptorExtranjeroFiscalInfoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const data = props.data || {};

    this.state = {
      data: data,
      validator: new Validator(data, this.rules)
    };
  }

  get rules() {
    return {
      NomDenRazSocR: ['required', 'string', 'min:1', 'max:300'],
      NumRegIdTribR: ['string', 'min:1', 'max:20'],
      Email: ['email', 'min:3', 'max:250']
    }
  }

  componentDidMount() {
    if (!!this.props.data) {
      this.handleOnChange({});
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnAdd = () => {
    const { data } = this.state;

    this.props.onChange({
      NacionalidadR: 'Extranjero',
      Extranjero: {
        ...data
      }
    });
  }

  handleOnCancel = () => {
    this.props.onChange({});
  }

  render() {
    const { data, isValid } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="Reg ID tributario"
          name="NumRegIdTribR"
          placeholder=""
          help=""
          minLength={ 1 }
          maxLength={ 20 }
          autoFocus={ true }
          rules={ this.rules.NumRegIdTribR }
          value={ data.NumRegIdTribR }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Razón social"
          name="NomDenRazSocR"
          placeholder=""
          help=""
          minLength={ 1 }
          maxLength={ 300 }
          rules={ this.rules.NomDenRazSocR }
          value={ data.NomDenRazSocR }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Email"
          name="Email"
          placeholder="email@example.com"
          help=""
          rules={ this.rules.Email }
          value={ data.Email }
          onChange={ this.handleOnChange }
        />

        <div>
          <Button variant="secondary"
            className="mt-3 mr-2"
            onClick={ this.handleOnCancel }
          >
            Cancelar
          </Button>
          <Button variant="primary"
            className="mt-3"
            disabled={ !isValid }
            onClick={ this.handleOnAdd }
          >
            Confirmar
          </Button>
        </div>

      </Form>
    )
  }
}

export default ReceptorExtranjeroFiscalInfoForm;